import React from 'react'
import { withRouter } from 'react-router-dom'
import { Button, Card } from 'antd-mobile'
import { Container, Wrapper } from '../../components_renew/Layout'
import api from '../../api'
import ImgUp from '../../assets/img/square_up.png'
import ImgDown from '../../assets/img/square_down.png'

@withRouter
class MessageDetails extends React.PureComponent {
  state = {
    content: <></>
  }

  componentDidMount () {
    document.title = '消息详情'
    this.fetchData()
  }

  render () {
    // 样式暂且就这样，后面估计要改
    const { content } = this.state
    return <Container>
      <Wrapper>
        {content}
      </Wrapper>
    </Container>
  }

  fetchData () {
    const { type, id } = this.props.match.params
    switch (type) {
      case '6':
        this.fetchType6(id)
        break
      case '7':
      case '8':
        this.fetchType78(id)
        break
      default:
        this.fetchType12(id)
    }
  }

  fetchType6 (id) {
    api.message.fetchMessageType6(id)
      .then(res => {
        const {
          message,
          activityTitle,
          direction,
          amount,
          ratio,
          sum,
          reward,
        } = res
        const content = <div className={'p-4'}>
          <Card title={`恭喜您！ ${message}`}>
            <div className={'leading-loose'}>
              <div className={'text-lg leading-loose'}>
                可前往 <Button
                size={'mini'}
                color={'primary'}
                onClick={() => this.props.history.push(window.PATH.INTEGRAL_DETAILS + '?hideHeader=1')}
              >积分明细</Button> 中查看
              </div>
              <br/>
              <div>
                <div>竞猜活动: {activityTitle}</div>
                <div>竞猜方向: {direction > 1 ? '猜利空' : '猜利多'}</div>
                <div>下注积分: {amount}</div>
                <div>所占比例: {ratio}</div>
                <div>瓜分积分: {sum}</div>
                <div>所得积分: {reward}</div>
              </div>
            </div>
          </Card>
        </div>
        this.setState({ content })
      })
  }

  fetchType78 (id) {
    api.message.fetchMessageType78(id)
      .then(res => {
        const {
          message,
          type,
          productName,
          unitMoney,
          sl,
          profitLoss,
          // profitOrLossRate,
          createOrderPrice,
          closeOrderPrice,
          createDate,
          closeOrderDate
        } = res
        // const content = <div>
        //   <div>首单保障 {message}</div>
        //   <div>可前往[我的积分]界面中，点击右上角按钮进入[积分明细]中查看</div>
        //   <div>
        //     <div>{productName} {unitMoney}元/单 {sl} [{type}]</div>
        //     <div>受益金额: {profitLoss}元</div>
        //     <div>下单价: {createOrderPrice}</div>
        //     <div>退订价: {closeOrderPrice}</div>
        //     <div>下单时间: {createDate}</div>
        //     <div>退订时间: {closeOrderDate}</div>
        //   </div>
        // </div>
        const content = <div className={'p-4'}>
          <Card title={`首单保障 ${message}`}>
            <div className={'leading-loose'}>
              <div className={'text-lg leading-loose'}>
                可前往 <Button
                size={'mini'}
                color={'primary'}
                onClick={() => this.props.history.push(window.PATH.INTEGRAL_DETAILS+'?hideHeader=1')}
              >积分明细</Button> 中查看
              </div>
              <br/>
              <div>
                <div>{productName} {unitMoney}元/单 {sl}</div>
                <div>受益金额: {profitLoss}元</div>
                <div className={'flex items-center'}>下单价: {createOrderPrice}&nbsp;
                  {type === '2'
                    ? <img src={ImgDown} alt=""/>
                    : <img src={ImgUp} alt=""/>}
                </div>
                <div>退订价: {closeOrderPrice}</div>
                <div>下单时间: {createDate}</div>
                <div>退订时间: {closeOrderDate}</div>
              </div>
            </div>
          </Card>
        </div>
        this.setState({ content })
      })
  }

  fetchType12 (id) {
    api.message.fetchMessageDetails(id)
      .then(res => {
        const {
          showOrderDescription,
          bsflag,
          stkname,
          holdmargin,
          orderqty,
          openprice,
          closeprice,
          opentime,
          closetime,
          closeprofit,
          profitOrLossRate,
          // orderstateName,
        } = res
        const content = <div className={'p-4'}>
          <Card title={`恭喜您！ ${showOrderDescription}`}>
            <div className={'leading-loose'}>
              <div className={'text-lg leading-loose'}>
                可前往 <Button
                size={'mini'}
                color={'primary'}
                onClick={() => this.props.history.push(window.PATH.INTEGRAL_DETAILS + '?hideHeader=1')}
              >积分明细</Button> 中查看
              </div>
              <br/>
              <div>
                <div>受益金额: {closeprofit}</div>
                <div>受益率: {profitOrLossRate}</div>
                <div>{bsflag === '买跌' ? <img src={ImgDown} alt=""/> : <img src={ImgUp} alt=""/>}&nbsp;
                  {stkname} {holdmargin}元/单 x {orderqty}
                </div>
                <div>下单价: {openprice}</div>
                <div>退订价: {closeprice}</div>
                <div>下单时间: {opentime}</div>
                <div>退订时间: {closetime}</div>
              </div>
            </div>
          </Card>
        </div>
        this.setState({ content })
      })
  }
}

export default MessageDetails
